// All overlay positions are expressed in the overlay layer's coordinate system.
export function missingRhythmGeometry(vf, element, layer) {
  const stave = vf?.getStave?.();
  const sourceMatrix = element?.getScreenCTM?.();
  const layerMatrix = layer?.getScreenCTM?.();
  if (!stave || !sourceMatrix || !layerMatrix) return null;
  const matrix = layerMatrix.inverse().multiply(sourceMatrix);
  const point = (x, y) => ({
    x: matrix.a * x + matrix.c * y + matrix.e,
    y: matrix.b * x + matrix.d * y + matrix.f,
  });
  const begin = vf.getNoteHeadBeginX?.() ?? vf.getAbsoluteX?.();
  const end = vf.getNoteHeadEndX?.() ?? begin;
  const x = (begin + end) / 2;
  const top = point(x, stave.getYForLine(0));
  const lineCount = Math.max(1, Number(stave.getNumLines?.() ?? 5));
  const bottom = point(x, stave.getYForLine(lineCount - 1));
  const middle = point(x, stave.getYForLine((lineCount - 1) / 2));
  const wholeRestLine = point(x, stave.getYForLine(lineCount === 1 ? 0 : 1));
  const noteY = vf.isRest?.() ? middle.y : point(x, vf.getYs?.()[0] ?? stave.getYForLine((lineCount - 1) / 2)).y;
  const spacing = Math.abs(point(x, stave.getYForLine(1)).y - top.y);
  if (![top.x, top.y, bottom.y, middle.y, noteY, spacing].every(Number.isFinite) || !spacing) return null;
  return { x: top.x, topY: top.y, bottomY: bottom.y, middleY: middle.y, wholeRestY: wholeRestLine.y, noteY, spacing, lineCount };
}

export function placedRhythmPosition(symbol, geometry, configuredScale = 1) {
  const multiplier = Number(configuredScale);
  const scale = geometry.spacing / 10 * (Number.isFinite(multiplier) && multiplier > 0 ? multiplier : 1);
  const rest = symbol.endsWith("_rest");
  const base = symbol.replace(/^dotted_/, "");
  // Rest positions are staff lines, independent of clef and source pitch.
  // Do not use getYs() for rests: its pitch-derived Y can change with clef.
  // drawGlyphSVG's rest paths have an internal translate(0, -15).
  const restLineY = base === "whole_rest"
    ? geometry.wholeRestY
    : geometry.middleY;
  return { scale, y: rest ? restLineY + 15 * scale : geometry.noteY };
}


// A hidden rest carries no useful note pitch. Follow the nearest visible note
// in the excerpt instead of using the rest's conventional middle-line anchor.
export function missingRhythmNoteY(geometry, candidates, targetIndex) {
  let closest = null;
  for (const candidate of candidates) {
    if (!Number.isFinite(candidate.y)) continue;
    if (!closest || Math.abs(candidate.index - targetIndex) < Math.abs(closest.index - targetIndex)) {
      closest = candidate;
    }
  }
  if (closest) return closest.y;
  return geometry.lineCount === 1 ? geometry.topY : geometry.bottomY - geometry.spacing / 2;
}
